import { useState, useEffect, useRef, memo } from 'react';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core';
import {
  DeleteOutline as VoidPickupIcon,
  RestoreFromTrash as UnvoidPickupIcon,
} from '@material-ui/icons';
import styles from './styles';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../../../../appConfigContext';
import { PICKUP_MANAGEMENT_MODES } from '../../../PickupManagement/constants';
import StyledToolTip from '../../../../../../../common/StyledToolTip';

const RenderPickupIcon = ({onClickHandler, iconComponent, title}) => (
  <div onClick={onClickHandler}>
    <StyledToolTip title={title}>
      {iconComponent}
    </StyledToolTip>
  </div>
);

const VoidAndUnvoidPickup = ({ classes, eventHub, headerId, configJSON }) => {
  const [pickupFlowFlags, setPickupFlowFlags] = useState({
    isVoidPickupFlow: configJSON.enableVoidPickup,
    isUnvoidPickupFlow: configJSON.enableUnvoidPickup,
    isSingleRowSelected: false
  });
  const isCompletedPickupRef = useRef(false);
  const isVoidedPickupRef = useRef(false);

  useEffect(() => {
    eventHub.on(`${headerId}_updatePickupManagementIconStatus`, changeVoidPickupStatus);
    return () => {
      eventHub.off(`${headerId}_updatePickupManagementIconStatus`, changeVoidPickupStatus);
    };
  }, []);

  const handleVoidPickup = () => {
    eventHub.emit('pickupManagement', {
      action: PICKUP_MANAGEMENT_MODES.VOID_PICKUP
    });
  };

  const handleUnvoidPickup = () => {
    eventHub.emit('pickupManagement', {
      action: PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP
    });
  };

  const changeVoidPickupStatus = ({ selectedPickups }) => {
    const { isCompleted, isVoided } = selectedPickups[0] ?? {};
    isCompletedPickupRef.current = isCompleted;
    isVoidedPickupRef.current = isVoided;
    const rowSelected = selectedPickups.length;
    const isVoidPickupFlow = !isCompleted && !isVoided;
    const isUnvoidPickupFlow = !isCompleted && isVoided;
    setPickupFlowFlags({
      isVoidPickupFlow,
      isUnvoidPickupFlow,
      isSingleRowSelected: rowSelected === 1
    });
  };

  const getVoidTooltipMessage = () => {
    if (!configJSON.enableVoidPickup) {
      return `Void Pickup (Disabled)`;
    } else if (!pickupFlowFlags.isSingleRowSelected) {
      return 'Select a single pickup to void';
    } else if (isVoidedPickupRef.current) {
      return 'Pickup is already voided';
    } else if (isCompletedPickupRef.current) {
      return 'Pickup is already completed';
    } else {
      return 'Click to Void Pickup';
    }
  };

  const getUnVoidTooltipMessage = () => {
    if (!configJSON.enableUnvoidPickup) {
      return `UnVoid Pickup (Disabled)`;
    } else if (!pickupFlowFlags.isSingleRowSelected) {
      return 'Select a single pickup to unvoid';
    } else if (isCompletedPickupRef.current) {
      return 'Pickup is already completed';
    } else if (!isVoidedPickupRef.current) {
      return 'Pickup is not voided yet';
    } else {
      return 'Click to Unvoid Pickup';
    }
  };

  const isEnabledIcon =
    pickupFlowFlags.isSingleRowSelected &&
    ((configJSON.enableVoidPickup && pickupFlowFlags.isVoidPickupFlow) ||
      (configJSON.enableUnvoidPickup && pickupFlowFlags.isUnvoidPickupFlow));
  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${
        isEnabledIcon ? classes.enabledIcon : classes.disableIcon
      }`}>
      {pickupFlowFlags.isVoidPickupFlow ? (
        <RenderPickupIcon
          onClickHandler={isEnabledIcon ? handleVoidPickup : null}
          iconComponent={<VoidPickupIcon />}
          title={getVoidTooltipMessage()}
        />
      ) : (
        <RenderPickupIcon
          onClickHandler={isEnabledIcon ? handleUnvoidPickup : null}
          iconComponent={<UnvoidPickupIcon />}
          title={getUnVoidTooltipMessage()}
        />
      )}
    </div>
  );
};

export default compose(
  withStyles(styles),
  withAppConfig,
  withSnackbar
)(memo(VoidAndUnvoidPickup));

